import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<App />);

// Manual CSS injection for .pac-container style
const pacStyle = document.createElement('style');
pacStyle.innerHTML = `
  .pac-container {
    z-index: 2000 !important;
    position: absolute !important;
  }
`;
document.head.appendChild(pacStyle);

if (import.meta.hot) {
  import.meta.hot.accept('./App', async () => {
    const { default: NextApp } = await import('./App');
    root.render(<NextApp />);
  });
}

reportWebVitals();
